import React from 'react';
import PropTypes from 'prop-types';
import {Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button} from '@material-ui/core';

export default class MessageDetailDialog extends React.Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    message: PropTypes.object.isRequired,
  };
  static defaultProps = {
    open: false,
  };

  render() {
    const {open, message, onClose} = this.props;
    return (
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="message-dialog-title"
        aria-describedby="message-dialog-description"
        className="message-dialog"
        fullWidth
      >
        <DialogTitle id="message-dialog-title">Message</DialogTitle>
        <DialogContent>
          <DialogContentText
            id="message-dialog-description"
            style={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
            }}
          >
            {message.body}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
